import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";

function CollapsableComponent({
  title = "Purchase Orders",
  defaultOpen = true,
  isOpen,
  onToggle,
  className = "",
  headerClassName = "",
  contentClassName = "",
  children,
  toolTip = "",
}) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isControlled = typeof isOpen === "boolean";
  const expanded = isControlled ? isOpen : internalOpen;

  useEffect(() => {
    if (!isControlled) {
      setInternalOpen(defaultOpen);
    }
  }, [defaultOpen, isControlled]);

  const handleToggle = () => {
    if (!isControlled) {
      setInternalOpen((prev) => !prev);
    }
    if (onToggle) {
      onToggle(!expanded);
    }
  };

  return (
    <div
      className={`w-full bg-white rounded-lg shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 ${className}`}
    >
      <button
        type="button"
        onClick={handleToggle}
        className={`w-full p-4 bg-white flex items-center justify-between ${headerClassName}`}
      >
        <div className="flex items-center gap-3">
          <span className="font-InterBold text-sm leading-5 text-slate-700">{title}</span>
          {toolTip && (
            <>
              <img
                src="/images/common/tooltip.png"
                alt="info"
                data-tooltip-id={title}
                data-tooltip-html={toolTip}
                className="w-3 h-3"
              />
              <Tooltip id={title} positionStrategy="fixed" />
            </>
          )}
        </div>
        <svg
          className={`w-4 h-4 text-slate-400 transition-transform duration-200 ${expanded ? "" : "rotate-180"}`}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12.5L10 7.5L15 12.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div className={`transition-opacity duration-200 ease-in-out ${expanded ? "opacity-100" : "hidden opacity-0"}`}>
        <div className={`w-full px-4 pb-4 ${contentClassName}`}>{children}</div>
      </div>
    </div>
  );
}

export default CollapsableComponent;
